import { URLs } from "./apis";
import {
  getVerifyStampCollectionCid,
  getVerifyStampTransactionHash,
  hasVerifyStampValue,
  selectVerifyStamp,
} from "./verifyStampLink";

export const verifyHashWorkerVerify = async (
  hash,
  supportedHashAlgoMap,
  setError,
  setStampData,
  setCurrentScreen,
  setObjectHash,
  setLoading,
  targetStamp = {},
) => {
  const url = new URL(window.location);
  const targetTransactionHash = getVerifyStampTransactionHash(targetStamp);
  const targetCollectionCid = getVerifyStampCollectionCid(targetStamp);

  url.searchParams.set("cid", hash);
  if (hasVerifyStampValue(targetTransactionHash)) {
    url.searchParams.set("transaction_hash", targetTransactionHash);
  } else {
    url.searchParams.delete("transaction_hash");
  }
  url.searchParams.delete("collection_id");
  if (hasVerifyStampValue(targetCollectionCid)) {
    url.searchParams.set("collection_cid", targetCollectionCid);
  } else {
    url.searchParams.delete("collection_cid");
  }
  window.history.pushState({}, "", url);
  // Check if hash exists before adding
  supportedHashAlgoMap ||= {};
  if (!(hash in supportedHashAlgoMap)) {
    supportedHashAlgoMap[hash] = hash;
  }
  // Get list of hashes
  const objectHashes = Object.keys(supportedHashAlgoMap || {});

  const requestData = {
    cids: objectHashes,
  };

  const csrfToken = document.querySelector("[name=csrfmiddlewaretoken]").value;
  try {
    setLoading(true);
    const response = await fetch(URLs.VERUFY_API_URL, {
      method: "POST",
      headers: {
        "X-CSRFToken": csrfToken,
      },
      body: JSON.stringify(requestData),
    });

    // Check if response is ok before parsing JSON
    if (!response.ok) {
      let errorResponse;
      try {
        errorResponse = await response.json();
      } catch {
        // If response is not JSON, create structured error
        errorResponse = {
          error: {
            user_message:
              "Unable to verify stamp. Please try again or contact support.",
            technical_details: {
              message: `HTTP ${response.status}: ${response.statusText}`,
              timestamp: new Date().toISOString(),
              error_type: "HTTP Error",
            },
          },
        };
      }

      // Set error in stampData to display through VerifiedFileError
      // VerifiedFileError expects error prop in format: { error: { user_message, technical_details } }
      setStampData(errorResponse);
      setCurrentScreen("fileLink");
      setError(null);
      setLoading(false);
      return;
    }

    const data = await response.json();

    // Check if API returned an error in the response body
    if (data.error) {
      // Data already has the expected format: { error: { ... } }
      setStampData(data);
      setCurrentScreen("fileLink");
      setError(null);
      setLoading(false);
      return;
    }

    if (data.stamp_list && data.stamp_list.length > 0) {
      const selectedStamp = selectVerifyStamp(data.stamp_list, {
        transactionHash: targetTransactionHash,
        collectionCid: targetCollectionCid,
      });

      if (!selectedStamp) {
        setStampData(null);
        setObjectHash(hash);
        setCurrentScreen("notfound");
        setError(null);
        setLoading(false);
        return;
      }

      const showDuplicateStampWarning =
        !hasVerifyStampValue(targetTransactionHash) &&
        data.stamp_list.length > 1;

      const stampData = {
        ...selectedStamp,
        display_timezone: data.display_timezone,
        showDuplicateStampWarning,
      };
      setStampData(stampData);
      setCurrentScreen("found");
      setError(null);
    } else {
      setStampData(null);
      setObjectHash(hash);
      setCurrentScreen("notfound");
      setError(null);
    }
    setLoading(false);
  } catch (error) {
    console.error("Error:", error);

    // Create structured error for network/parsing errors
    const errorResponse = {
      error: {
        user_message:
          "Unable to connect to the server. Please check your internet connection and try again.",
        technical_details: {
          message: error.message || "Network error occurred",
          timestamp: new Date().toISOString(),
          error_type: "Network Error",
        },
      },
    };

    // Set error in stampData to display through VerifiedFileError
    // VerifiedFileError expects error prop in format: { error: { user_message, technical_details } }
    setStampData(errorResponse);
    setCurrentScreen("fileLink");
    setError(null);
    setLoading(false);
  }
};
